import { Component, OnInit, Inject, PLATFORM_ID, ChangeDetectorRef } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Product } from '../models/product.model';
import { MrpScrolltopComponent } from '../services/mrp-scrolltop/mrp-scrolltop.component';

import { FooterComponent } from '../footer/footer.component'; 

@Component({
    selector: 'app-bootcamp',
    templateUrl: './bootcamp.component.html',
    styleUrls: ['./bootcamp.component.css'],
    imports: [MrpScrolltopComponent, RouterLink, FooterComponent]
})
export class BootcampComponent implements OnInit {

  classes: Product[] = [];
  displayedColumns: string[] = ['name', 'description', 'price', 'action'];
  isLoading = false;
  isInitiatingCheckout = false;
  noClassesMessage: string = '';
  isBrowser = false;

  constructor(private router: Router, private http: HttpClient, 
    @Inject(PLATFORM_ID) private platformId: Object, private cdr: ChangeDetectorRef) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {

      this.isLoading = true;
      if (this.isBrowser) {
        this.http.post<Product[]>('api/products/getBootcampClasses.php', {}).subscribe({
            next: (data) => {
              this.classes = data;
              this.isLoading = false;
              this.cdr.markForCheck();
            },
            error: (error) => {
              console.error('Error fetching products:', error);
              this.isLoading = false;
              this.cdr.markForCheck();
            }
          });
        this.logPage('bootcamp');
      } else {
        // Avoid server-side HTTP calls during prerender
        this.isLoading = false;
      }
  }

  logPage(urlName: string): void {
    if (!this.isBrowser) return;
    this.http.post('/api/access/access_log.php', {urlName: urlName}).subscribe();
  }


  gotoClass(item_CODE: string){
      this.router.navigate(['/bootcamp-detail', item_CODE]);  
  }

  async initiateCheckout(priceId: string, mode: 'payment' | 'subscription') {
    this.isInitiatingCheckout = true;
    this.http.post<{ sessionId: string, stripeKey: string, sessionUrl: string }>('api/create-checkout-session/create-checkout-session.php', { priceId, mode }).subscribe({
      next: async (response) => {
        // Redirect to Stripe Checkout
       this.redirectTo(response.sessionUrl); // Redirect to Checkout
      },
      error: (error) => {
        this.isInitiatingCheckout = false;
        console.error('Error creating checkout session:', error);
        this.cdr.markForCheck();
      }
    });
  }

  scrollTo(sectionId: string): void {
    const element = document.getElementById(sectionId);
    if (element) {
      // Use scrollIntoView with 'smooth' behavior for a nice effect
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }  

  // Wrapper to make redirects testable
  redirectTo(url: string): void {
    window.location.assign(url);
  }

}
